import { Box, Button, FormControl, Grid, Typography } from '@material-ui/core';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useSession } from '../../../Session';
import { useDeleteAccountMutation } from '../../../api';
import Dialog from '../../../components/Dialog';
import OutlinedInputField from '../../../components/fields/OutlinedInputField';
import { useHandleError } from '../../../utilities/handleErrors';

export type DeleteAccountDialogProps = {
    open: boolean;
    onClose: () => void;
};

type formValue = {
    confirmation?: string;
};

const DeleteAccountDialog = ({ open, onClose }: DeleteAccountDialogProps) => {
    const { t } = useTranslation(['profilePage']);
    const { setToken } = useSession();
    const [deleteAccount] = useDeleteAccountMutation();

    const submitDeleteAccount = useHandleError(async () => {
        const result = await deleteAccount();
        if (result?.data?.isDeleted) {
            setToken(null);
            onClose();
        }
    }, [onClose]);

    return (
        <Dialog maxWidth="sm" onCloseClick={onClose} open={open} title={t('profilePage:deleteAccountDialog.title')}>
            <Formik<formValue>
                initialValues={{ confirmation: '' }}
                onSubmit={submitDeleteAccount}
                validate={values => {
                    const error: formValue = {};
                    if (!values.confirmation || values.confirmation?.toLowerCase() !== 'delete') {
                        error.confirmation = t('profilePage:deleteAccountDialog.error.deleteInputRequired');
                    }

                    return error;
                }}
            >
                {({ isSubmitting }) => (
                    <Form>
                        <Grid spacing={2} container>
                            <Grid item>
                                <Typography>{t('profilePage:deleteAccountDialog.message')}</Typography>
                            </Grid>
                            <Grid item>
                                <Typography>{t('profilePage:deleteAccountDialog.confirmationMessage')}</Typography>
                            </Grid>
                            <Grid xs={12} item>
                                <OutlinedInputField autoComplete="off" name="confirmation" fullWidth />
                            </Grid>
                        </Grid>
                        <Box alignItems="center" mt={2}>
                            <FormControl fullWidth>
                                <Button color="secondary" disabled={isSubmitting} type="submit" variant="contained">
                                    {t('profilePage:deleteAccountDialog.confirmButton')}
                                </Button>
                            </FormControl>
                        </Box>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};
export default DeleteAccountDialog;
